import type { BasOrd, OrdstodNiva, OrdstodSidecar } from "./types";
import { nivaIndex } from "./types";

export interface OrdTraff { start: number; end: number; lemma: string }

// form (lowercase) -> lemma, restricted to the course level (nivaTak) and to
// lemmas present in both sidecar and baslista. Unknown sidecar lemmas are
// skipped silently — validate-ordstod (Task 12) reports them at build time.
export function buildFormIndex(
  sidecar: OrdstodSidecar,
  baslista: Map<string, BasOrd>,
  kursNiva: OrdstodNiva,
): Map<string, string> {
  const idx = new Map<string, string>();
  for (const { lemma } of sidecar.ord) {
    const bas = baslista.get(lemma);
    if (!bas) continue;
    if (nivaIndex(kursNiva) > nivaIndex(bas.nivaTak)) continue;
    for (const form of bas.former) idx.set(form.toLowerCase(), lemma);
  }
  return idx;
}

// Unicode-aware word chars incl. Swedish letters (\p{L} covers åäö).
// Internal hyphens are part of the token so hyphenated lemmas like
// "y-skärning" match as one word instead of splitting at the dash.
const WORD_RE = /\p{L}+(?:-\p{L}+)*/gu;

export function matchText(text: string, formIndex: Map<string, string>): OrdTraff[] {
  if (formIndex.size === 0) return [];
  const out: OrdTraff[] = [];
  for (const m of text.matchAll(WORD_RE)) {
    const lemma = formIndex.get(m[0].toLowerCase());
    if (lemma) out.push({ start: m.index, end: m.index + m[0].length, lemma });
  }
  return out;
}
